// #region Imports
import React from 'react';
/**
 * To show Trip Warnings
 */
import TripWarning from './TripWarning';
/**
 * To Display Phone Icon
 */
import {IconPhone} from '../../Icons';
//#endregion

/**
* It is written in Directions>>TripWarnings>>AdvanceReservationWarning .
* Used in Directions>>TripWarnings>>Index
* If any trip requires advance reservation then this component shows a message for that.
* @param {Object} 'Trip Details'
* @return {Object} Trip Warning Html 
*/
const AdvanceReservationWarning = props => {
    return (
        <TripWarning
            icon={<IconPhone />}
            screenReaderText='Alert: Advance reservation required'
            summaryText='Some of your trips require advance reservation.'
            {...props}
        />
    );
};

export default AdvanceReservationWarning;